import axios from "axios"
export const createBusiness = (bData, token) => {
   return axios.post(process.env.REACT_APP_API_URL+ '/createBusiness', bData, {
      headers: {
          'Authorization': `${token}`
      }});
}